namespace Solovis.Notes.NoteEditor {

    /**
     * options = { links, saveCallback }
     * where links is optional specification of items to link, links: { entityId, contactId }
     * where saveCallback should be a function with noteContext arg that is called if note is saved.
     * @param options
     */
    export function addNote(options) {
        var links = options.links ? options.links : null;

        var saveCallback = options.saveCallback ? options.saveCallback : null;

        Solovis.Rpc.invokeAndWait("~/DataManagement/NoteEditor/CreateNote", { links: links },
            function (response, success) {
                if (success) {
                    var note = response.result.note;
                    Solovis.Notes.NoteEditor.editNote({
                        noteId: note.noteId,
                        saveCallback: saveCallback
                    });
                }
            });
    }

    export function editNote(options) {
        var editorOptions: any = {};
        if (options.noteId) {
            editorOptions.noteId = options.noteId;
        }
        else {
            throw "options.noteId not specified";
        }

        // saveCallback should be a function with no args that is called if note is saved.
        var saveCallback = options.saveCallback ? options.saveCallback : null;

        var formDiv = $("<div>").css("position", "relative").css("height", "100%");

        var noteEditorDiv = $("<div>").css("height", "100%").appendTo(formDiv);
        var noteEditorControlHost = new Solovis.UI.ControlHost({ container: noteEditorDiv });
        var noteEditorControl = null;

        var dialog = new Solovis.UI.Dialog({
            container: formDiv,

            title: "Edit Note",
            modal: true,
            destroyOnClose: true,
            actions: ["Close"],

            buttons: [
                {
                    label: "Save",
                    click: function () {
                        if (noteEditorControl) {
                            noteEditorControl.save();
                        }
                    }
                },
                {
                    label: "Save and Close",
                    click: function () {
                        if (noteEditorControl) {
                            noteEditorControl.save(function () {
                                dialog.close();
                            });
                        }
                    }
                },
            ],

            activate: function () {
                Solovis.ModuleLoader.loadModuleByName(
                    "Solovis.NoteEditor",
                    function () {
                        noteEditorControl = new (Solovis as any).Notes.Editors.NoteEditorControl(editorOptions);
                        noteEditorControlHost.setCurrentControl(noteEditorControl);
                    });
            },

            close: function () {
                if (noteEditorControl) {
                    if (noteEditorControl.noteContentSaved) {
                        if (saveCallback) {
                            saveCallback({
                                noteId: noteEditorControl.noteId
                            });
                        }
                    }
                }
            },

            deactivate: function () {
                noteEditorControlHost.setCurrentControl(null);
            }
        });

        dialog.maximize();
        dialog.open();
    }
}
